import { Box, Flex, Text, Divider, VStack, HStack } from "@chakra-ui/react";

import { $ok } from "foundation-ts/commons";
import { Nullable } from "foundation-ts/types";

import { formatDate, maskCard, maskIban } from "./helpers";
import { Mandate } from "./types";
import { Card } from "./UI";

interface MandateCardProps {
    mandate: Nullable<Mandate>;
    onUpdate: (mandate: Mandate) => void;
}

export function MandateCard({ mandate, onUpdate }: MandateCardProps) {
    // const mandateModal = useDisclosure();

    // const [selectedMethod, setSelectedMethod] = useState<PaymentMethodType>("sepa");
    // const [mandateForm, setMandateForm] = useState<MandateFormData>({
    //     method: "sepa",
    //     iban: "",
    //     bic: "",
    //     accountHolder: "",
    //     bank: "",
    //     cardLast4: "",
    //     cardBrand: "",
    //     cardExpiry: "",
    // });

//   const isSepaValid =
//         selectedMethod === "sepa" &&
//         mandateForm.iban.replace(/\s/g, "").length >= 14 &&
//         mandateForm.bic.trim().length >= 8 &&
//         mandateForm.accountHolder.trim().length > 0;

//   const isCardValid =
//         selectedMethod === "card" &&
//         (mandateForm.cardLast4?.length === 4) &&
//         (mandateForm.cardExpiry?.trim().length ?? 0) >= 4 &&
//         mandateForm.accountHolder.trim().length > 0;

//   const isFormValid = isSepaValid || isCardValid;

//   function openMandateModal(): void {
//         setSelectedMethod(mandate.method ?? "sepa");
//         setMandateForm({
//             method: mandate.method ?? "sepa",
//             iban: "",
//             bic: "",
//             accountHolder: mandate.accountHolder,
//             bank: mandate.bank,
//             cardLast4: "",
//             cardBrand: "",
//             cardExpiry: "",
//         });
//         mandateModal.onOpen();
//     }

//   function handleUpdate(): void {
//         if (!isFormValid) return;
//         const base = {
//             accountHolder: mandateForm.accountHolder.trim(),
//             bank: mandateForm.bank?.trim() ?? "",
//             signedAt: new Date().toISOString().slice(0, 10),
//             reference: `MNDT-${new Date().getFullYear()}-${String(Math.floor(Math.random() * 90000) + 10000)}`,
//         };

//         if (selectedMethod === "sepa") {
//             onUpdate({
//                 ...base,
//                 method: "sepa",
//                 iban: mandateForm.iban.trim(),
//                 bic: mandateForm.bic.trim(),
//             });
//         } else {
//             onUpdate({
//                 ...base,
//                 method: "card",
//                 iban: "",
//                 bic: "",
//                 cardLast4: mandateForm.cardLast4?.trim(),
//                 cardBrand: mandateForm.cardBrand?.trim(),
//                 cardExpiry: mandateForm.cardExpiry?.trim(),
//             });
//         }
//         mandateModal.onClose();
//     }

    const isCard = $ok(mandate?.cardNumber);

    return (
        <>
            <Card>
                <Flex justify="space-between" align="center" mb={5}>
                    <HStack spacing={2}>
                        <Text fontFamily="heading" fontSize="lg" color="gray.900">
                            Mandat {isCard ? "Carte bancaire" : "SEPA"}
                        </Text>
                        {/* {!isCard && <SepaTag />} */}
                    </HStack>
                    {/* <Button size="xs" variant="outline" borderColor="gray.200" color="gray.600" _hover={{ bg: "gray.50" }} onClick={openMandateModal}>
                        Mettre à jour
                    </Button> */}
                </Flex>

                <VStack spacing={4} align="stretch">
                    <Box bg="surface.subtle" borderRadius="12px" p={4}>
                        <Text fontSize="xs" color="gray.400" mb={1} textTransform="uppercase" letterSpacing="wider">Titulaire</Text>
                        <Text fontSize="sm" fontWeight="600" color="gray.800">{mandate?.holder}</Text>
                    </Box>

                    {isCard ? (
                        <>
                            <Box>
                                <Text fontSize="xs" color="gray.400" mb={1} textTransform="uppercase" letterSpacing="wider">Numéro de carte</Text>
                                <Text fontSize="sm" fontWeight="600" color="gray.800" fontFamily="mono" letterSpacing="wider">
                                    {maskCard(mandate?.cardNumber ?? "????")}
                                </Text>
                            </Box>
                            {$ok(mandate?.cardExpiryDate) && (
                                <Box>
                                    <Text fontSize="xs" color="gray.400" mb={1} textTransform="uppercase" letterSpacing="wider">Expiration</Text>
                                    <Text fontSize="sm" fontWeight="600" color="gray.800" fontFamily="mono">{mandate?.cardExpiryDate}</Text>
                                </Box>
                            )}
                        </>
                    ) : (
                        <>
                            <Box>
                                <Text fontSize="xs" color="gray.400" mb={1} textTransform="uppercase" letterSpacing="wider">IBAN</Text>
                                <Text fontSize="sm" fontWeight="600" color="gray.800" fontFamily="mono" letterSpacing="wider" wordBreak="break-all">
                                    {maskIban(mandate?.consumerAccount!)}
                                </Text>
                            </Box>
                            <Flex gap={6} wrap="wrap">
                                <Box flex={1} minW="100px">
                                    <Text fontSize="xs" color="gray.400" mb={1} textTransform="uppercase" letterSpacing="wider">Référence</Text>
                                    <Text fontSize="xs" fontWeight="500" color="gray.600" wordBreak="break-all">{mandate?.reference}</Text>
                                </Box>
                            </Flex>
                        </>
                    )}

                    <Divider borderColor="gray.100" />
                    <Text fontSize="xs" color="gray.400">Mis à jour le {formatDate(mandate?.signatureDate)}</Text>
                </VStack>
            </Card>

            {/* <Modal isOpen={mandateModal.isOpen} onClose={mandateModal.onClose} size="md" isCentered>
                <ModalOverlay backdropFilter="blur(4px)" />
                <ModalContent borderRadius="20px" p={2}>
                    <ModalHeader fontFamily="heading">Mettre à jour le paiement</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack spacing={5} align="stretch">
                            <Box>
                                <Text fontSize="xs" color="gray.500" textTransform="uppercase" letterSpacing="wider" mb={3}>
                                    Méthode de paiement
                                </Text>
                                <Flex gap={3}>
                                    <MethodTab
                                        value="sepa"
                                        selected={selectedMethod === "sepa"}
                                        icon={<BankIcon />}
                                        label="Virement SEPA"
                                        description="Prélèvement automatique"
                                        onClick={() => setSelectedMethod("sepa")}
                                    />
                                    <MethodTab
                                        value="card"
                                        selected={selectedMethod === "card"}
                                        icon={<CardIcon />}
                                        label="Carte bancaire"
                                        description="CB, Visa, Mastercard"
                                        onClick={() => setSelectedMethod("card")}
                                    />
                                </Flex>
                            </Box>

                            <Box bg="orange.50" borderRadius="12px" p={3} border="1px solid" borderColor="orange.100">
                                <Text fontSize="xs" color="orange.700">
                                    {selectedMethod === "sepa"
                                        ? "Un nouveau mandat remplacera l'actuel et prendra effet sur votre prochain prélèvement."
                                        : "La nouvelle carte remplacera le moyen de paiement actuel dès validation."}
                                </Text>
                            </Box>

                            <FormControl isRequired>
                                <FormLabel fontSize="sm" color="gray.600">Titulaire du compte</FormLabel>
                                <Input placeholder="ACME SAS" value={mandateForm.accountHolder}
                                       onChange={(e) => setMandateForm((f) => ({ ...f, accountHolder: e.target.value }))}
                                       borderRadius="10px" fontSize="sm" />
                            </FormControl>

                            {selectedMethod === "sepa" && (
                                <>
                                    <FormControl isRequired>
                                        <FormLabel fontSize="sm" color="gray.600">IBAN</FormLabel>
                                        <Input placeholder="FR76 XXXX XXXX XXXX XXXX XXXX XXX" value={mandateForm.iban ?? ""}
                                               onChange={(e) => setMandateForm((f) => ({ ...f, iban: e.target.value }))}
                                               borderRadius="10px" fontSize="sm" fontFamily="mono" />
                                    </FormControl>
                                    <FormControl isRequired>
                                        <FormLabel fontSize="sm" color="gray.600">BIC / SWIFT</FormLabel>
                                        <Input placeholder="BNPAFRPP" value={mandateForm.bic ?? ""}
                                               onChange={(e) => setMandateForm((f) => ({ ...f, bic: e.target.value.toUpperCase() }))}
                                               borderRadius="10px" fontSize="sm" fontFamily="mono" maxLength={11} />
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel fontSize="sm" color="gray.600">
                                            Banque <Text as="span" color="gray.400">(optionnel)</Text>
                                        </FormLabel>
                                        <Input placeholder="BNP Paribas" value={mandateForm.bank ?? ""}
                                               onChange={(e) => setMandateForm((f) => ({ ...f, bank: e.target.value }))}
                                               borderRadius="10px" fontSize="sm" />
                                    </FormControl>
                                </>
                            )}

                            {selectedMethod === "card" && (
                                <>
                                    <FormControl isRequired>
                                        <FormLabel fontSize="sm" color="gray.600">4 derniers chiffres de la carte</FormLabel>
                                        <Input
                                            placeholder="1234"
                                            value={mandateForm.cardLast4 ?? ""}
                                            onChange={(e) => setMandateForm((f) => ({ ...f, cardLast4: e.target.value.replace(/\D/g, "").slice(0, 4) }))}
                                            borderRadius="10px" fontSize="sm" fontFamily="mono"
                                            maxLength={4}
                                        />
                                    </FormControl>
                                    <Flex gap={3}>
                                        <FormControl>
                                            <FormLabel fontSize="sm" color="gray.600">
                                                Réseau <Text as="span" color="gray.400">(optionnel)</Text>
                                            </FormLabel>
                                            <Input placeholder="Visa" value={mandateForm.cardBrand ?? ""}
                                                onChange={(e) => setMandateForm((f) => ({ ...f, cardBrand: e.target.value }))}
                                                borderRadius="10px" fontSize="sm" />
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel fontSize="sm" color="gray.600">Expiration</FormLabel>
                                            <Input
                                                placeholder="MM/AA"
                                                value={mandateForm.cardExpiry ?? ""}
                                                onChange={(e) => {
                                                    let v = e.target.value.replace(/\D/g, "").slice(0, 4);
                                                    if (v.length >= 3) v = v.slice(0, 2) + "/" + v.slice(2);
                                                    setMandateForm((f) => ({ ...f, cardExpiry: v }));
                                                }}
                                                borderRadius="10px" fontSize="sm" fontFamily="mono"
                                                maxLength={5}
                                            />
                                        </FormControl>
                                    </Flex>
                                    <Box bg="blue.50" borderRadius="10px" p={3} border="1px solid" borderColor="blue.100">
                                        <Text fontSize="xs" color="blue.700">
                                            Pour des raisons de sécurité, nous ne stockons pas votre numéro de carte complet. 
                                            Seuls les 4 derniers chiffres sont conservés à titre d'identification.
                                        </Text>
                                    </Box>
                                </>
                            )}
                        </VStack>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button variant="ghost" onClick={mandateModal.onClose}>Annuler</Button>
                        <Button bg="brand.500" color="white" _hover={{ bg: "brand.600" }}
                                isDisabled={!isFormValid} onClick={handleUpdate}>
                            Enregistrer
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal> */}
        </>
    );
}